import { useCallback } from 'react'
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3'

const RECAPTCHA_TIMEOUT = 5000 // 5 seconds timeout

const useRecaptcha = () => {
    const { executeRecaptcha } = useGoogleReCaptcha()

    const isReady = !!executeRecaptcha

    const getToken = useCallback(
        async (actionName) => {
            if (!executeRecaptcha) {
                console.warn('[reCAPTCHA] Not initialized yet')
                return null
            }

            try {
                const tokenPromise = executeRecaptcha(actionName)
                const timeoutPromise = new Promise((_, reject) =>
                    setTimeout(() => reject(new Error('reCAPTCHA timeout')), RECAPTCHA_TIMEOUT)
                )

                const token = await Promise.race([tokenPromise, timeoutPromise])
                return token
            } catch (error) {
                console.error('[reCAPTCHA] Token generation failed:', error.message)
                return null
            }
        },
        [executeRecaptcha]
    )

    return { getToken, isReady }
}

export default useRecaptcha